<!-- 缺陷reopen -->
<template>
  <div>
    <a-row>
      <a-col :span="24">
        <a-card title="AI客服回复质检TOP10" size="small">
          <a-table :columns="ticketListColumns" :style="{ height: height, width: width }" :data-source="topTicket" row-key="id">
            <span slot="reason" slot-scope="text, record">
              <span v-if="record.reason === null || record.reason === ''">--</span>
            </span>
            <span slot="name" slot-scope="text, record">
              <a @click="toDetail(record.id)">{{ record.name }}</a>
            </span>
          </a-table>
        </a-card>
      </a-col>
      <a-col :span="24">
        <a-card title="AI客服回复质检BOT10" size="small">
          <a-table :columns="ticketListColumns" :style="{ height: height, width: width }" :data-source="botTicket" row-key="id">
            <span slot="name" slot-scope="text, record">
              <a @click="toDetail(record.id)">{{ record.name }}</a>
            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <div v-if="tableData">
      <ticket-list-modal ref="ticketListModal" :task-list="tableData" :user-list="userList" :tag-list="tagList" />
    </div>
    <ticket-drawer v-if="editVisible" :visible="editVisible" :ticket-id="ticketId" @close="close" />
  </div>
</template>
<script>
import { doGetAiQua } from '@/api/data/ticket';
import TicketDrawer from '@/pages/event/components/TicketDrawer';
import TicketListModal from '@/pages/data/ticket/components/TicketListModal';
import { ticketDomain, ticketAiResultPie } from '@/utils/dictionary';
export default {
  components: { TicketListModal, TicketDrawer },
  props: {
    width: {
      type: String,
      default: '95%'
    },
    userList: {
      type: Array,
      default: () => []
    },
    tagList: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '360px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 4, // 每页中显示20条数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      editVisible: false,
      ticketId: 0,
      myChart: null,
      myDomainChart: null,
      myAiResultChart: null,
      modalVisible: false,
      loading: true,
      ticketDomain,
      ticketAiResultPie,
      title: '',
      tableData: [],
      topTicket: [],
      botTicket: [],
      ticketList: [],
      ticketTableData: [],

      ticketListColumns: [
        {
          title: '工单标题',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '得分',
          dataIndex: 'parsed_point',
          key: 'parsed_point',
          scopedSlots: { customRender: 'parsed_point' }
        },
        {
          title: '扣分原因',
          dataIndex: 'reason',
          key: 'reason',
          scopedSlots: { customRender: 'reason' }
        }
      ]
    };
  },
  computed: {
    taskLink() {
      return record => {
        const route = this.$router.resolve({
          name: 'page:event:ticket:detail',
          query: { ticketId: record.id }
        });
        return route.href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    this.getDiagramData();
  },

  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    close() {
      this.editVisible = false;
    },
    toDetail(ticketId) {
      this.ticketId = ticketId;
      this.editVisible = true;
    },
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    getDiagramData() {
      this.loading = true;
      doGetAiQua(this.filterForm).then(res => {
        this.topTicket = res.data[0];
        this.botTicket = res.data[1];
      });
    }
  }
};
</script>
